module.exports = __webpack_public_path__ + "74648b5e14dd1fff271900e50a2a642b.gif";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/snake.gif
// module id = 970
// module chunks = 2